import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation, Thumbs } from 'swiper/modules';

export default class extends module {
    constructor(m) {
        super(m);

        this.length = this.$('item').length
        this.carousel = this.$('carousel')[0];
        this.carouselThumbnail = this.$('thumbnail')[0]
        this.navigationPrev = this.$('prev')[0]
        this.navigationNext = this.$('next')[0]
    }

    init() {
        this.carousel = new Swiper(this.carousel, {
            modules: [Navigation, Thumbs],
            loop: true,
            speed: 700,
            spaceBetween: 15,
            grabCursor: true,
            navigation: {
                prevEl: this.navigationPrev,
                nextEl: this.navigationNext
            },
            thumbs: {
                swiper: this.carouselThumbnail
            },
            breakpoints: {
                700: {
                    spaceBetween: 30,
                    speed: 900,
                },
                1000: {
                    spaceBetween: 50,
                }
            }
        })

        this.carouselThumbnail = new Swiper(this.carouselThumbnail, {
            loop: true,
            spaceBetween: 5,
            slidesPerView: 6,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                700: {
                    spaceBetween: 20,
                }
            }
        })

        if( this.length < 6) {
            this.$('thumbnail')[0].classList.add('-center');
        }
    }

    destroy() {
        super.destroy()
        this.carousel?.destroy(true, true)
        this.carouselThumbnail?.destroy(true, true)
    }
}
